import { defineMessages } from "react-intl";

export const messages = defineMessages({
  header: {
    id: "fi9Qa/",
    defaultMessage: "Dry run",
    description: "Dry run dialog header",
  },
  unavailableSyncEvents: {
    id: "TnnDjx",
    defaultMessage: "Dry run currently is not available for synchronous events",
    description: "Dry run sync events alert",
  },
  selectObject: {
    id: "+RffqY",
    defaultMessage: "Select object type to perform dry run on provided query",
    description: "Dry run dialog object title",
  },
  unavailableEvents: {
    id: "BYTvv/",
    defaultMessage:
      "The following events from provided query are currently not available for dry run:",
    description: "Dry run events unavailable",
  },
  objects: {
    id: "uccjUM",
    defaultMessage: "Objects",
    description: "Dry run objects",
  },
  noObjects: {
    id: "0u9Ng0",
    defaultMessage: "No objects found in the provided query",
    description: "Dry run no objects found",
  },
  item: {
    id: "ZepEWY",
    defaultMessage: "Item",
    description: "Dry run item",
  },
  itemsDefaultMessage: {
    id: "5b0Boq",
    defaultMessage: "Choose the object",
    description: "Dry run items list default message",
  },
  run: {
    id: "48dMqY",
    defaultMessage: "Run",
    description: "Dry run trigger button",
  },
});
